<template>
  <div ref="wrapper" :class="[wrapperClass]"
    class="overflow-auto disable-scrollbars button-swipe-wrapper">
    <b-button-group ref="buttonGroup" :class="[groupClass, 'button-swipe']">
      <b-button
        v-for="(option, index) in options"
        :class="[itemClass, index < options.length - 1 ? 'mr-1' : '']"
        class="ml-0"
        variant="outline-primary rounded text-nowrap"
        :pressed="pressedButtonsValues.includes(option.value)"
        :key="index"
        @click="buttonClicked(option.value)">{{option.description}}
      </b-button>
    </b-button-group>
  </div>
</template>

<script>
export default {
  name: 'ButtonSwipe',
  data() {
    return {
      pressedButtonsValues: [],
    };
  },
  props: {
    options: {
      type: Array,
      required: true,
      validator(entries) {
        return entries
          && entries.length > 0
          && entries.every(obj => Object.prototype.hasOwnProperty.call(obj, 'description')
          && Object.prototype.hasOwnProperty.call(obj, 'value'));
      },
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false,
    },
    value: {
      type: [String, Array],
      required: false,
    },
    wrapperClass: {
      type: String,
      default: '',
    },
    groupClass: {
      type: String,
      default: '',
    },
    itemClass: {
      type: String,
      default: '',
    },
  },
  methods: {
    buttonClicked(optionValue) {
      let pressedButtons;
      if (this.multiple) {
        if (this.pressedButtonsValues.includes(optionValue)) {
          this.pressedButtonsValues.splice(this.pressedButtonsValues.indexOf(optionValue), 1);
        } else {
          this.pressedButtonsValues.push(optionValue);
        }
        pressedButtons = [...this.pressedButtonsValues];
      } else {
        if (this.pressedButtonsValues.length > 0 && this.pressedButtonsValues[0] === optionValue) {
          this.pressedButtonsValues = [];
        } else {
          this.pressedButtonsValues = [optionValue];
        }
        pressedButtons = this.pressedButtonsValues.length === 0 ? '' : this.pressedButtonsValues[0];
      }
      this.$emit('input', pressedButtons);
      this.$emit('change', pressedButtons);
    },
    checkPreDefinedValues() {
      if (this.value) {
        if (typeof this.value === 'string') {
          this.pressedButtonsValues = [this.value];
        } else {
          this.pressedButtonsValues = this.value;
        }
      } else if (typeof this.value === 'string') {
        this.pressedButtonsValues = [];
      }
    },
  },
  created() {
    this.checkPreDefinedValues();
  },
  beforeUpdate() {
    this.checkPreDefinedValues();
  },
  watch: {
    value: {
      handler() {
        this.checkPreDefinedValues();
      },
    },
  },
};
</script>
